import React, { useState, useCallback } from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import LearningAdminModuleSeriesTableList from '../containers/LearningAdminModuleSeriesTableListContainer';

const LearningAdminModuleSeriesTableScreen = ({
  total,
  setShowList,
  setGlobalTotal,
  page,
  limit,
  order,
  filter,
  component,
  view,
  activeKey,
  trackerActions,
  ...props
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const action = 'all';

  const updateSelectedRowKeys = useCallback(
    (newKeys, insert, except) => {
      setSelectedRowKeys((prevSelectedRowKeys) => {
        if (except) {
          return newKeys;
        } else {
          if (insert) {
            return [...prevSelectedRowKeys, newKeys];
          } else {
            const indice = prevSelectedRowKeys.indexOf(newKeys);
            if (indice !== -1) {
              const newSelectedRowKeys = [...prevSelectedRowKeys];
              newSelectedRowKeys.splice(indice, 1);
              return newSelectedRowKeys;
            }
          }
        }
        return prevSelectedRowKeys;
      });
    },
    [setSelectedRowKeys]
  );

  return (
    <Translation>
      {(t) => (
        <>
          <LearningAdminModuleSeriesTableList
            page={page}
            limit={limit}
            order={order}
            action={action}
            setShowList={setShowList}
            setGlobalTotal={setGlobalTotal}
            selectedRowKeys={selectedRowKeys}
            updateSelectedRowKeys={updateSelectedRowKeys}
            filter={filter}
            component={component}
            view={view}
            activeKey={activeKey}
            trackerActions={trackerActions}
          />
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleSeriesTableScreen);

Logger.log('silly', `LearningAdminModuleSeriesTableScreen loaded.`);
